
import { Options, Vue, Watch } from "vue-property-decorator";
import DefaultLayout from "@/layout/DefaultLayout.vue";
import { namespace } from "vuex-class";
import { FilterMatchMode } from "primevue/api";

const PageModule = namespace("pages");
@Options({
  components: { DefaultLayout },
})
export default class PageList extends Vue {
  private resource = "api/pages";

  private filter!: any;
  private filters = {
    slug: { value: null, matchMode: FilterMatchMode.CONTAINS },
    titleDe: { value: null, matchMode: FilterMatchMode.CONTAINS },
    titleEn: { value: null, matchMode: FilterMatchMode.CONTAINS },
  };
  private sort!: any;
  private page = 1;
  private itemsPerPage = 50;

  @PageModule.Action("findAll")
  private findAllAction: any;

  @PageModule.Action("del")
  protected deleteAction: any;

  @PageModule.Getter("getDataList")
  private pages: any;

  @PageModule.Getter("getDeletedSuccess")
  private deletedSuccess: any;

  @PageModule.Getter("getTotal")
  private total: any;

  @PageModule.Getter("getIsLoading")
  private isLoading: any;

  private onFilter($event: any): void {
    console.log($event);
    this.sort =
      $event.sortOrder !== 0
        ? [
            {
              field: $event.sortField,
              type: $event.sortOrder == 1 ? "asc" : "desc",
            },
          ]
        : null;
    this.filter = $event.filters;
    this.page = $event.page + 1;
    const params = {
      filter: this.filter,
      sort: this.sort,
      page: this.page,
      itemsPerPage: this.itemsPerPage,
    };

    this.findAllAction({
      resource: this.resource,
      params: params,
    });
  }

  private addPage(): void {
    this.$router.push({ name: "PageAdd" });
  }
  private editPage(page: any): void {
    console.log(page);
    this.$router.push({ name: "PageEdit", params: { id: page?.id } });
  }

  private deletePage($event: any, page: any): void {
    this.$confirm.require({
      target: $event.currentTarget,
      message: this.$t("question.remove_item"),
      rejectLabel: this.$t("general.no"),
      acceptLabel: this.$t("general.yes"),
      acceptClass: "p-button-danger",
      rejectClass: "p-button-text p-button-danger",
      icon: "pi pi-question-circle",
      accept: () => {
        this.deleteAction({ resource: this.resource, id: page.id });
      },
    });
  }

  private refresh(): void {
    this.loadData({
      filter: this.filter,
      sort: this.sort,
      page: this.page,
      itemsPerPage: this.itemsPerPage,
    });
  }

  private loadData(params?: any): void {
    this.findAllAction({
      resource: this.resource,
      params: params,
    });
  }

  @Watch("deletedSuccess", { immediate: false, deep: false })
  private onDeletedSuccess(success: any): void {
    if (success === true) {
      this.refresh();
    }
  }

  public mounted(): void {
    this.refresh();
  }
}
